var _defs, _use, _use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSLogoAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .shape { fill: #fff; }\r\n    "), /*#__PURE__*/React.createElement("symbol", {
    id: "semiWithBite",
    viewBox: "0 0 59.82 29.91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,29.91                A29.91,29.91 0 0,1 59.82,29.91                L59.82,29.91 L0,29.91 Z",
    fill: "#fff",
    mask: "url(#biteMask)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "biteMask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.82,
    height: 29.91,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.91,29.91                  A18,18 0 0,1 47.91,29.91                  L47.91,29.91 L11.91,29.91 Z",
    fill: "#000"
  }))))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#semiWithBite",
    className: "shape",
    x: 20,
    y: 40
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#semiWithBite",
    className: "shape",
    x: 100,
    y: 40
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSLogoAlt);
export default __webpack_public_path__ + "static/media/SLogoAlt.746b74967837af554f7c6ff36079a062.svg";
export { ForwardRef as ReactComponent };